import { Injectable } from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {FleetAndUserService} from "../services/fleet-and-user.service";
import {Observable, of} from "rxjs";
import {FleetUserActionTypes, FleetUserSaved, FleetUserSaveFail} from "../actions/fleet-user.actions";
import {catchError, map, mergeMap} from "rxjs/operators";



@Injectable()
export class FleetAndUserEffects {

  @Effect()
  saveFleetAndUser$: Observable<any> = this.actions$.pipe(
    ofType(FleetUserActionTypes.SaveFleetUser),
    mergeMap(action =>
      this.fleetAndUserService.saveFleetAndUser().pipe(
        map(data => {
          window.location.replace(data.result.redirect);
        }),
        catchError((err) => of(new FleetUserSaveFail(err)))
      )
    )
  )


  constructor(private actions$: Actions,
              private fleetAndUserService:FleetAndUserService) {}

}
